import client from "./client";

const googleLogin = (data: {credential?: string; accessToken?: string; deviceId?: string; inviteCode?: string; promoCode?: string; affilkaTag: string}) =>
    client.post("/googleLogin", data);

const getBeeAuthUrl = () => client.post("/beenetwork/getAuthUrl");

const beeLogin = (data: {code: string; state: string; inviteCode?: string; promoCode?: string}) => client.post("/beenetwork/beeLogin", data);

const getMetaMaskNonce = (publicAddress: string) => client.get("/metamask/nonce", {params: {publicAddress}});

const metaMaskLogin = (data: {publicAddress: string; signData: string; signature: string; inviteCode?: string; promoCode?: string; affilkaTag: string}) =>
    client.post("/metamask/login", data);

const tgLogin = (data: Record<string, string>) => client.post("/tgLogin", data);

const tgAppLogin = (data: Record<string, string>) => client.post("/tgAppLogin", data);

const sendFaceBookDotData = (data: {eventName: string}) => client.post("/sendFaceBookDotData", data);

const sendFaceBookUserData = (data: {channel_code: string; fbc: string; external_id: string; userId: number; ttclid: string}) =>
    client.post("/sendFaceBookUserData", data);

const registerEmail = ({
    nickName,
    email,
    verifiactionCode,
    password,
    birth,
    inviteCode,
    promoCode,
    affilkaTag,
}: {
    nickName: string;
    email: string;
    password: string;
    affilkaTag: string;
    birth: string;
    inviteCode?: string;
    promoCode?: string;
    verifiactionCode?: string;
}) =>
    client.post("/register", {
        ...(promoCode ? {promoCode: promoCode} : {inviteCode: inviteCode || "-1"}),
        type: 1,
        nickName,
        verifiactionCode,
        email,
        password,
        affilkaTag,
        birth,
        langId: 2,
    });

const registerMobile = ({
    mobile,
    verifiactionCode,
    password,
    inviteCode,
    promoCode,
}: {
    mobile: string;
    verifiactionCode: number;
    password: string;
    inviteCode?: string;
    promoCode?: string;
}) =>
    client.post("/register", {
        ...(promoCode ? {promoCode: promoCode} : {inviteCode: inviteCode || "-1"}),
        type: 2,
        mobile,
        verifiactionCode,
        password,
        langId: 2,
    });

const sendPixelClickId = (click_id: string, bundle_id: string) =>
    client.post("/sendUserDotData", {
        type: 4,
        click_id,
        bundle_id,
    });
const getWithdrawLimit = (type = 0) => client.post("/getWithdrawLimit", {type});

const getUserChargeAmountUsd = () => client.post("/getUserChargeAmountUsd");

const getVipMonthData = () => client.post("/getVipMonthData");

const getVipMonthRewards = (tokenId: number, type: number) => client.post("/getVipMonthRewards", {tokenId, type});

const getVipCashbackData = (data = {}) => client.post("/getVipCashbackData", data);

const getVipInstantCashbackData = (data = {}) => client.post("/getVipInstantCashbackData", data);

const getVipCashbackRewards = (data = {}) => client.post("/getVipCashbackRewards", data);

const queryVipLevelUpData = (data = {}) => client.post("/queryVipLevelUpData", data);

const getVipLevelUpReward = (data = {}) => client.post("/getVipLevelUpReward", data);

const getUserInfo = () => client.post("/getUserData");

const queryChargActivityList = (data = {}) => client.post("/queryChargActivityList", data);

const getWebSocketUrl = () => client.post("/getWebSocketUrl");

const getAppVersion = () => client.post("/getAppVersion");

const sendUserDotData = (appsflyer_id: string, advertising_id: string, bundle_id: string) =>
    client.post("/sendUserDotData", {type: 1, appsflyer_id, advertising_id, bundle_id});

const sendKwaiViewDotData = (clickid: string, channelCode: string) =>
    client.post("/sendKwaiViewDotData", {
        clickid,
        channelCode,
    });

const changeLanguage = (languageId: number | string) => client.post("/changeLanguage", {languageId});

const getDepositRewardByLast = () => client.post("/getDepositRewardByLast");

const login = (type: "email" | "mobile", content: string, password: string, twoFaCode?: number) =>
    client.post("/login", {
        type: type === "email" ? 1 : 2,
        email: type === "email" ? content : "",
        mobile: type === "mobile" ? content : "",
        password,
        twoFaCode,
    });

export type FacebookDataParams = {
    userId: number | undefined;
    adtrack: string;
    utrack: string;
    eventName: string;
    payData?: {type: string; amount: number; orderId: string};
};

const sendDotChickenDotData = (data: FacebookDataParams) => client.post("/sendDotChickenDotData", data);

const sendDotChickenUserData = (data: {adtrack: string; utrack: string; uniqueId: string}) => client.post("/sendDotChickenUserData", data);

const getRestrictLoginList = (data = {}) => client.post("/getRestrictLoginList", data);

const checkUserExistByAccount = (account: string, type: "email" | "mobile") =>
    client.post("/checkUserExistByAccount", {account, type: type === "email" ? 1 : 2});

const receiveManualBonus = (data = {}) => client.post("/receiveManualBonus", data);

const getManualBonus = (data = {}) => client.post("/getManualBonus", data);

const apiAuth = {
    sendFaceBookDotData,
    sendFaceBookUserData,
    googleLogin,
    tgLogin,
    tgAppLogin,
    getMetaMaskNonce,
    metaMaskLogin,
    getBeeAuthUrl,
    beeLogin,
    registerEmail,
    registerMobile,
    sendPixelClickId,
    getWithdrawLimit,
    getUserChargeAmountUsd,
    getVipMonthData,
    getVipMonthRewards,
    getVipCashbackData,
    getVipInstantCashbackData,
    getVipCashbackRewards,
    getUserInfo,
    queryChargActivityList,
    getWebSocketUrl,
    queryVipLevelUpData,
    getVipLevelUpReward,
    sendUserDotData,
    sendKwaiViewDotData,
    getAppVersion,
    changeLanguage,
    getDepositRewardByLast,
    login,
    sendDotChickenDotData,
    sendDotChickenUserData,
    getRestrictLoginList,
    checkUserExistByAccount,
    receiveManualBonus,
    getManualBonus,
};

export default apiAuth;
